import produce, { enableES5 } from "immer";
enableES5();
import { Reducer } from "redux";
import { IDocumentRequestListModel } from "src/Core/ViewModels/documentRequest/DocumentRequestModel";

export enum MovingRequestActions {
    ADD = "addMovingRequests",
    REMOVE = "removeMovingRequests",
}

interface MovingRequestAction {
    type: MovingRequestActions;
    payload: IDocumentRequestListModel[];
}

/**
 * * To handle message selection in common place
 * @param state array of selected message iDs
 * @param action select or unselect messages
 * @returns state and dispatch action method
 */
export const movingRequestReducer: Reducer<IDocumentRequestListModel[], MovingRequestAction> = produce(
    (draft: IDocumentRequestListModel[] = [], action: MovingRequestAction) => {
        switch (action.type) {
            case MovingRequestActions.ADD:
                draft = action.payload;
                break;
            case MovingRequestActions.REMOVE: {
                draft = [];
                break;
            }
        }
        return draft;
    }
);
